const englishTranslations = {
  general: {
    oops: 'Oops, something went wrong!',
    noRecords: 'No records',
    loading: 'Loading',
    pageNotFound: 'Page not found',
    open: 'Open',
  },
  loginPage: {
    verificationCodeMessage:
      'We have sent a verification code to $0. This code will be valid for 60 seconds.',
    verificationCode: 'Verification code',
    requestNewCodeProblems:
      'Any issues with your code? You can request a new code via the button below.',
    incorrectCode: "The code you've entered is incorrect",
    incorrectEmailOrPassword: 'Incorrect email or password',
    requestNewCode: 'Request new code',
    MFA: 'Multi-factor Authentication',
    confirm: 'Confirm',
    email: 'Email',
    password: 'Password',
    logIn: 'Log in',
  },
  mainPage: {
    showToasts: 'Show Toasts',
  },
  menu: {
    logout: 'Logout',
  },
  transactionsPage: {
    name: 'Name',
    transactionDate: 'Transaction data',
    amount: 'Amount',
    product: 'Product',
    description: 'Description',
    metaDescription: 'Meta description',
    priceExVat: 'Price Ex. VAT',
    priceIncVat: 'Price Inc. VAT',
    note: 'Note',
    category: 'Category',
    status: 'Status',
    receipt: 'Receipt',
    reset: 'Reset',
    download: 'Download',
    pending: 'Pending',
    noReceiptAvailable: 'No receipt available',
    consumers: 'Consumers',
    all: 'All',
    organisation: 'Organisation',
    youngCapital: 'Young Capital',
    booking: 'Booking',
    sungevity: 'Sungevity',
    aethon: 'Aethon',
    budbee: 'Budbee',
    searchTransactions: 'Search transactions',
    transactions: 'Transactions',
  },
  businessCardsPage: {
    id: 'Identifier',
    all: 'All',
    product: 'Product',
    addons: 'Addons',
    businessCards: 'NS Business Cards',
    searchBusinessCards: 'Search Business Cards',
    fullName: 'User name',
    email: 'Email',
    engravedCardId: 'Card ID',
    contractStart: 'Contract start',
    contractEnd: 'Contract end',
    reset: 'Reset',
    class: 'Class',
    status: 'Status',
    organisation: 'Organisation',
    uploadBusinessCardsXlsx: 'Upload Business Cards XLSX',
    uploadSuccessful: 'Successfully uploaded Business Cards',
  },
  transactionStatus: {
    completed: 'Completed',
    authorised: 'Authorised',
    refunded: 'Refunded',
    cancelled: 'Cancelled',
    pending: 'Pending',
    uploaded: 'Uploaded',
    skipped: 'Skipped',
    publicTransport: 'Public transport',
    activated: 'Activated',
    deactivated: 'Deactivated',
    invited: 'Invited',
    active: 'Active',
    closed: 'Closed',
    suspended: 'Suspended',
  },
  transactionPage: {
    title: 'Transaction by $0 on $1',
    transactionDetails: 'Transaction Details',
    fullName: 'Full Name',
    transactionDate: 'Transaction data',
    amount: 'Amount',
    product: 'Product',
    priceExVat: 'Price Excluding VAT',
    priceIncVat: 'Price Including VAT',
    note: 'Note',
    email: 'Email',
    type: 'Type',
    description: 'Description',
    category: 'Category',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    provider: 'Provider',
    fare: 'Fare',
    additionalDetails: 'Additional details',
    metaDescription: 'Meta description',
    addMetaDescriptionData: 'Add meta description',
    updateMetaDescriptionData: 'Update meta description',
    update: 'Update',
    restore: 'Restore',
    status: 'Status',
    checkInCheckOut: '$0, $1',
    actions: 'Actions',
    resetToPending: 'Reset to Pending',
  },
  route: {
    login: 'Login',
    main: 'Main',
    statistics: 'Statistics',
    drivers: 'Drivers',
    driver: 'Driver',
    transaction: 'Transaction Details',
    transactions: 'Transactions',
    notFound: 'Not Found',
    metaRules: 'Meta Rules',
    configuration: 'Configuration',
    vouchers: 'Vouchers',
    voucher: 'Voucher',
    privacy: 'Privacy',
    reservation: 'Reservation',
    reservations: 'Reservations',
    travelCards: 'Travel Cards',
    businessCards: 'NS Business Cards',
    product: 'Product',
    products: 'Products',
    organisation: 'Organisation',
    organisations: 'Organisations',
    pushNotifications: 'Push notifications',
    balanceAccounts: 'Balance accounts',
    community: 'Community',
    communities: 'Communities',
    invites: 'Invites',
    transactionRuleGroups: 'Transaction rule groups',
    transactionRuleGroup: 'Transaction rule group',
    custom: 'Custom Reports',
  },
  metaRulesPage: {
    metaRules: 'Meta rules',
    restore: 'Restore',
    update: 'Update',
    description: 'Description',
    target: 'Target',
    transportationType: 'Transportation type',
    fuelType: 'Fuel type',
    pricePerKilometer: 'Price per kilometer',
  },
  configurationPage: {
    configuration: 'Configuration',
    status: 'Signup enabled',
    darkMode: 'Dark mode',
    restore: 'Restore',
    update: 'Update',
  },
  statisticsPage: {
    period: 'Period',
    organisation: 'Organisation',
    organisations: 'Organisations',
    consumers: 'Consumers',
    employees: 'Employees',
    users: 'Users',
    providers: 'Providers',
    provider: 'Provider',
    numberOfUsers: 'Number of users',
    all: 'All',
    pastDays: 'Past $0 days',
    pending: 'Pending',
    skipped: 'Skipped',
    converted: 'Converted',
    completed: 'Completed',
    publicTransport: 'Public transport',
    singleGraph: 'Single graph',
    multipleGraphs: 'Multiple graphs',
    reservations: 'Reservations',
    receipts: 'Receipts',
    top10Days: 'Top 10 days of reservations',
    bottom10Days: 'Bottom 10 days of reservations',
    date: 'Date',
    amount: 'Amount',
    private: 'Private',
    business: 'Business',
    reservationTypes: 'Reservation types',
    cancelled: 'Cancelled',
    completedVsCancelled: 'Completed vs cancelled',
    completedReservations: 'Completed reservations',
    cancelledReservations: 'Cancelled reservations',
    check: 'Check',
    vecore: 'Vecore',
    felyx: 'Felyx',
    mywheels: 'MyWheels',
    mywheelsCommission: 'MyWheels Commission',
    greenwheels: 'Greenwheels',
    greenwheelsCommission: 'Greenwheels Commission',
    greenwheels_rnp: 'Greenwheels RNP',
    greenwheels_rnpCommission: 'Greenwheels RNP Commission',
    adyen: 'Adyen',
    ns: 'NS',
    mrr: 'MRR',
    forecasted: 'Forecasted',
    status: 'Status,',
    name: 'Name',
    value: 'Value',
    annualGrowthRate: 'Annual growth rate',
    monthlyGrowthRate: 'Monthly growth rate',
    total: 'Total',
    derivedData: 'Derived data',
    spendByProvider: 'Spend by provider',
    spend: 'Spend',
    type: 'Type',
    totalSpend: 'Total spend (YTD)',
    monthlyRecurringRevenue: 'Monthly recurring revenue (MRR)',
    activeUsers: 'Activated users',
    totalUsers: 'New users',
    month: 'Month',
    exportCSV: 'Export CSV',
    usageFee: 'Usage fee',
    oneTimeFee: 'One-time fee',
    credit: 'Credit',
    passthrough: 'Pre-financed',
    other: 'Other',
    filters: 'Filters',
    filtersRevenueOnly: 'Revenue only',
    filtersMrrOnly: 'MRR only',
    filtersGmv: 'GMV',
    vat: 'VAT',
    vatExcl: 'Excl. VAT',
    vatIncl: 'Incl. VAT',
    // Cashflow tab
    cashflow: 'Cashflow',
    cashflowInvoiced: 'Invoiced per month',
    // MRR tab
    mrrRange: 'Range',
    mrrRangeMonths: 'Last $0 months',
    mrrInclVat: 'Incl. VAT',
    mrrByCustomer: 'MRR by customer',
    mrrPerMonth: 'MRR per month',
    mrrBreakdownOf: 'What makes up $0',
    mrrExplainer:
      'Every subscription invoice line is spread evenly over the period it covers; a month’s MRR is the sum of the shares that land in it.',
    mrrCurrent: 'MRR $0',
    mrrChange: 'Change',
    mrrChangeVsPrevious: 'vs previous month',
    mrrArr: 'ARR (MRR × 12)',
    mrrCustomers: 'Customers',
    mrrPerCustomer: 'Per customer',
    mrrLines: 'Lines',
    mrrOther: 'Other',
    mrrSelectMonthHint: 'Click a month to see which invoice lines make up its MRR.',
    mrrNoContributions: 'No recurring revenue in this month.',
    mrrCustomer: 'Customer',
    mrrProduct: 'Product',
    mrrDescription: 'Description',
    mrrShare: 'This month',
    mrrLineTotal: 'Invoice line total',
    mrrAmountsInclVat: 'Amounts include VAT.',
    mrrAmountsExclVat: 'Amounts exclude VAT.',
    mrrNoValue: '—',
    mrrMultiplePeriods: 'Multiple',
    mrrSeeLines: 'See invoice lines',
    mrrLinesDialogTitle: 'Invoice lines',
    mrrLinesCount: '$0 invoice lines',
    mrrOverMonths: 'over $0 months',
    close: 'Close',
    // MRR forecast
    mrrForecast: 'Forecast',
    mrrForecastShow: 'Show forecast (beta)',
    mrrForecastMonths: 'Next $0 months',
    mrrForecastOf: 'Forecast for $0',
    mrrForecastExplainer:
      'The forecast projects the coming months from the billing contracts, with the same schedule as the scheduled invoices of an organisation: a fixed contract term stops at its end, an indefinite one keeps going.',
    mrrContractEnd: 'Contract ends',
    mrrOpenEnded: 'Indefinite',
  },
  dualListEditor: {
    addMore: 'Add more',
    required: 'required',
  },
  driversPage: {
    name: 'Name',
    email: 'Email',
    phoneNumber: 'Phone number',
    accountCreatedOn: 'Account created on',
    organisation: 'Organisation',
    status: 'Status',
    exportAllDrivers: 'Export all drivers',
    syncGreenwheels: 'Sync Greenwheels',
    all: 'All',
    cancel: 'Cancel',
    cookie: 'Cookie',
    cookieExplanation:
      'Please login to the Greenwheels dashboard and copy the Cookie header from any graphql call in your browser inspector.',
    consumers: 'Consumers',
    searchDrivers: 'Search drivers',
    drivers: 'Drivers',
    areYouSure: 'Are you sure?',
    confirm: 'Confirm',
    successfullySyncedGreenwheels: 'Successfully synced Greenwheels',
  },
  driverPage: {
    details: 'Details',
    communities: 'Communities',
    wallet: 'Wallet',
    greenwheels: 'Greenwheels',
    mywheels: 'MyWheels',
    cardNumber: 'Card Number',
    driverId: 'Driver ID (Greenwheels)',
    providers: 'Providers',
    balance: 'Balance',
    reservations: 'Reservations',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phoneNumber: 'Phone number',
    address: 'Address',
    zipCode: 'Zip code',
    city: 'City',
    verified: 'Verified',
    addressIsVerified: 'Address is verified',
    addressIsNotVerified: 'Address is not verified',
    dateOfBirth: 'Date of birth',
    countryCode: 'Country code',
    reference: 'Reference',
    startsOn: 'Starts on',
    endsOn: 'Ends on',
    accountDetails: 'Account details',
    personalInformation: 'Personal information',
    hasPaymentInformation: 'Has payment information',
    driversLicense: 'Drivers license',
    documentNumber: 'Document number',
    expiryDate: 'Expiry date',
    organisation: 'Organisation',
    organisationName: 'Organisation name',
    dasboardAccess: 'Dashboard access',
    '2FA': '2FA',
    '2FAEnabled': '2FA enabled',
    travelCard: 'Travel card',
    hasMyWheels: 'Has registered account',
    travelCardEnabled: 'Travel card enabled',
    communityName: 'Community name',
    fleets: 'Fleets',
    editable: 'Editable',
    yes: 'Yes',
    no: 'No',
    id: 'Id',
    travelCardId: 'Travel card id',
    status: 'Status',
    maskedNumber: 'Masked number',
    activate: 'Activate',
    suspend: 'Suspend',
    creditCardNumber: '**** **** **** $0',
    anonymizeAccount: 'Anonymize account',
    cancel: 'Cancel',
    confirm: 'Confirm',
    areYouSure: 'Are you sure?',
    anonymizeAccountMessage:
      'You are about to anonymize the account with email $0. This action cannot be ondone. Please enter the email address again to confirm.',
    successfullyAnonymizedAccount: 'Account successfully anonymized!',
    successfullyEditOrganisation: 'Organisation successfully edited!',
    successfullyEditPersonalInformation: 'Personal information successfully edited!',
    successfullyAddedWalletBalance: 'Successfully updated balance!',
    successfullyEditDetails: 'Details successfully edited!',
    successfullyAddDriversLicense: 'Drivers license successfully added!',
    restore: 'Restore',
    save: 'Save',
    acceptDriversLicense: 'Accept drivers license',
    AM: 'AM',
    B: 'B',
    issuedOn: 'Issued on',
    name: 'Name',
    driver: 'Driver',
    startDate: 'Start date',
    endDate: 'End date',
    price: 'Price',
    provider: 'Provider',
    type: 'Type',
    deactivate: 'Deactivate',
    dialogDeactivateTitle: 'Are you sure you want to set this driver to inactive?',
    dialogDeactivateMessage:
      "The driver won't be able to (un)lock the vehicle or end the reservation anymore. Please make sure there isn't an active reservation.",
    dialogDeactivateSuccess: 'Driver successfully deactivated!',
    dialogActivateTitle: 'Are you sure you want to set this driver to active?',
    dialogActivateSuccess: 'Driver successfully activated!',
    resendInvite: 'Resend invite',
    resendInviteSuccess: 'Invite successfully resent!',
    validatePayment: 'Validate payment',
    remitInvoices: 'Remit invoices',
    remitInvoicesSucces: 'Invoices are succesfully remitted!',
    role: 'Role',
    employee: 'Employee / Driver',
    dashboardAdmin: 'Dashboard Admin',
    dashboardSuperAdmin: 'Dashboard Super Admin',
  },
  button: {
    actions: 'actions',
  },
  vouchersPage: {
    title: 'Voucher Templates',
    codePhrase: 'Code phrase',
    type: 'Type',
    value: 'Value',
    validFrom: 'Valid from',
    validTo: 'Valid To',
    maximumRides: 'Maximum rides',
    timesRedeemed: 'Times redeemed',
    searchTemplates: 'Search templates',
    all: 'All',
    discounts: 'Discounts',
    percentage: 'Percentage',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    areYouSure: 'Are you sure?',
    deleteVouchersMessage: 'You are about to delete $0 vouchers. This action cannot be ondone.',
    deleteVoucherMessage: 'You are about to delete 1 voucher. This action cannot be ondone.',
    cancel: 'Cancel',
  },
  voucherPage: {
    codePhrase: 'Code phrase',
    type: 'Type',
    value: 'Value',
    discountCents: 'Discounts in cents',
    validFrom: 'Valid from',
    validTo: 'Valid To',
    maximumRides: 'Maximum rides',
    timesRedeemed: 'Times redeemed',
    save: 'Save',
    update: 'Update',
    cancel: 'Cancel',
    restore: 'Restore',
    successfullyAdded: 'Voucher successfully added!',
    successfullyEdited: 'Voucher successfully edited!',
    percentage: 'Percentage',
    discount: 'Discount',
    dialogTitle: 'Are you sure?',
    dialogMessage: 'You are about to set the discount to $0.',
    confirm: 'Confirm',
  },
  reservationPage: {
    cancelledOn: 'Cancelled on',
    startDate: 'Start date',
    endDate: 'End date',
    createdOn: 'Created on',
    startedOn: 'Started on',
    closedOn: 'Closed on',
    price: 'Price',
    newPrice: 'New price',
    status: 'Status',
    provider: 'Provider',
    type: 'Type',
    organisation: 'Organisation',
    vehicle: 'Vehicle',
    identifier: 'Identifier',
    externalIdentifier: 'External identifier',
    invoiceIdentifier: 'Invoice identifier',
    finalizedOn: 'Finalized on',
    licensePlate: 'License plate',
    lockVehicle: 'Lock vehicle',
    unlockVehicle: 'Unlock vehicle',
    closeReservation: 'Close reservation',
    cancelReservation: 'Cancel reservation',
    invoiceReservation: 'Invoice reservation',
    lockVehicleDialogTitle: 'Are you sure you want to lock the vehicle?',
    lockVehicleDialogMessage:
      'Make sure the driver is not driving the vehicle or present in the vehicle. Ask driver for confirmation afterwards.',
    lockVehicleSuccess: 'Vehicle locked',
    unlockVehicleDialogTitle: 'Are you sure you want to unlock the vehicle?',
    unlockVehicleDialogMessage:
      "Make sure the legitimate driver's at the vehicle to avoid unwarranted break-ins or fines.",
    unlockVehicleSucces: 'Vehicle unlocked',
    closeReservationDialogTitle: 'Are you sure you want to close the reservation?',
    closeReservationDialogMessage:
      '$0 can still open or close the reservation for a short while depending on the provider.',
    closeReservationSuccess: 'Reservation closed',
    cancelReservationDialogTitle: 'Are you sure you want to cancel the reservation?',
    cancelReservationDialogMessage:
      'User will not be able to access the vehicle, and may have to pay a cancellation fee if not cancelled far enough in advance.',
    cancelReservationSuccess: 'Reservation cancelled',
    invoiceReservationDialogTitle: 'Invoice this reservation',
    invoiceReservationSuccess: 'Reservation is invoiced',
    confirm: 'Confirm',
    cancel: 'Cancel',
    forceClose: 'Force close',
    forceCloseWarning:
      'WARNING! Force closing a reservation while it is still open at our partner will result in an endless ride and high costs! Only close when you are certain our partners have closed the reservation!',
    forceClosePleaseEnter: 'Please enter the email address again to confirm.',
    email: 'Email',
    restore: 'Restore',
    update: 'Update',
  },
  reservationsPage: {
    driver: 'Driver',
    organisation: 'Organisation',
    searchOrganisation: 'Search organisation',
    startDate: 'Start date',
    endDate: 'End date',
    completed: 'Completed',
    price: 'Price',
    status: 'Status',
    provider: 'Provider',
    type: 'Type',
    check: 'Check',
    felyx: 'Felyx',
    figo: 'Figo',
    greenwheels: 'Greenwheels',
    amber: 'Amber',
    myWheels: 'Mywheels',
    all: 'All',
    consumers: 'Consumers',
    youngCapital: 'Young Capital',
    booking: 'Booking',
    sungevity: 'Sungevity',
    aethon: 'Aethon',
    budbee: 'Budbee',
    private: 'Private',
    business: 'Business',
    future: 'Future',
    upcoming: 'Upcoming',
    active: 'Active',
    started: 'Started',
    ended: 'Ended',
    past: 'Past',
    cancelled: 'Cancelled',
    email: 'Email',
    name: 'Name',
    promotionalCode: 'Promo code',
    searchReservations: 'Search reservations',
    reservations: 'Reservations',
    exportReservations: 'Export reservations',
    cancel: 'Cancel',
    confirm: 'Confirm',
    true: 'True',
    false: 'False',
  },
  travelCardsPage: {
    brand: 'Brand',
    issuedOn: 'Issued on',
    maskedNumber: 'Masked number',
    name: 'Name',
    email: 'Email',
    organisation: 'Organistaion',
    status: 'Status',
    adyenId: 'Adyen id',
  },
  productsPage: {
    add: 'Add',
    name: 'Name',
    priceIncVAT: 'Price inc. VAT.',
    priceExlVAT: 'Price exl. VAT.',
    vatAmount: 'VAT amount',
    vatDescription: 'VAT description',
    vatPercentage: 'VAT percentage',
    addProduct: 'Add product',
    billingFrequency: 'Billing frequency',
    billingFrequencyNote:
      'Note: Products that have a billing frequency higher than 1 month, will be used when calculating MRR, but invoices need to be created manually in Exact for now.',
  },
  productPage: {
    name: 'Name',
    priceExlVAT: 'Price exl. VAT.',
    VAT: 'VAT',
    cancel: 'Cancel',
    restore: 'Restore',
    save: 'Save',
    update: 'Update',
    successfullyAdded: 'Product successfully added',
    successfullyEdited: 'Product successfully edited',
    dialogTitle: 'Are you sure?',
    dialogMessage: 'You are about to set the price exl. VAT. to $0.',
    confirm: 'Confirm',
    billingFrequency: 'Billing Frequency',
  },
  organisationsPage: {
    name: 'Name',
    contactEmailAddress: 'Contact email address',
    id: 'Id',
    activeForInvoicing: 'Active for invoicing',
    showOnlyActiveForInvoicing: 'Show only active for invoicing',
    searchOrganisations: 'Search organisations',
    organisations: 'Organisations',
    addOrganisation: 'Add organistation',
  },
  organisationPage: {
    organisation: 'Organisation',
    contact: 'Contact',
    commissions: 'Commissions',
    invoicing: 'Invoicing',
    features: 'Features',
    impersonate: 'Impersonate organisation',
    openedLink: 'Link opened in a new tab',
    merchantCategoryCodes: 'Merchant Category Codes',
    connections: 'Connections',
    name: 'Name',
    contactEmailAddress: 'Contact email address',
    id: 'Id',
    KVK: 'KVK',
    VAT: 'VAT',
    stripeCustomerId: 'Stripe customer Id',
    communityId: 'Community Id',
    platformType: 'Platform type',
    firstName: 'First Name',
    lastName: 'Last name',
    email: 'Email',
    phoneNumber: 'Phone number',
    reservationsNotificationsEmail: 'Email for upcoming reservation notifications',
    reference: 'Reference',
    active: 'Active for monthly invoicing',
    paymentToEmployee: 'Payment to employee',
    bookingTransactionNote: 'Booking/Transaction note',
    emissionReportAccess: 'Emission report access',
    travelCard: 'Travel card',
    travelCardFeatures: 'TravelCard settings',
    kilometerRegistration: 'Kilometer registration',
    travelCardsByDefault: 'TravelCard for every user',
    reservationsNotifications: 'Enable upcoming reservation notifications',
    outsideOfficeHours: 'Enable outside of office hours',
    topSpendingEmployees: 'Enable top spending employees',
    compensations: 'Enable compensations',
    allowPhysicalCards: 'Enable physical TravelCards',
    showSupportPhoneNumber: 'Show support phone number in app',
    travelCardPersonalCode: 'Skip TravelCard personal code',
    enableEmployeeDashboard: 'Enable employee dashboard',
    NSBusinessCards: 'Enable NS business cards',
    monthlyInvoicedProducts: 'Monthly invoiced products',
    discount: 'Discount',
    resetDefaults: 'Reset defaults',
    addUser: 'Add user',
    addUsersInBulk: 'add users in Bulk',
    cancel: 'Cancel',
    save: 'Save',
    restore: 'Restore',
    remove: 'Remove',
    update: 'Update',
    export: 'Export',
    dialogResendInvitesTitle: 'Are you sure you want to resend the invitations?',
    dialogResendInvitesMessage:
      "Make sure you don't do this too often. Not only will it impact our email score but might drive customers away.",
    dialogResendInvitesSuccess: 'Emails sent',
    confirm: 'Confirm',
    resendInvites: 'Resend invites',
    downloadBulkInvites: 'Download bulk invites',
    uploadUserXlsx: 'Upload user XLSX',
    uploadSuccessful: 'Upload successful!',
    connected: 'Connected',
    disconnected: 'Disconnected',
    editAfasConnection: 'Edit AFAS connection',
    dialogAFASConnectionTitle: 'Add AFAS connection',
    connectorName: 'Connector name',
    environment: 'Enviroment',
    environmentId: 'Enviroment id',
    token: 'Token',
    tokenPlaceHolder: '<token><version>x</version><data>Token</data></token>',
    test: 'Test',
    acceptance: 'Acceptance',
    production: 'Production',
    dialogAddUserSuccess: 'User successfully added!',
    add: 'Add',
    dialogAFASConnectionSuccess: 'AFAS coneection successfully edited!',
    editOrganisationSuccess: 'Organisation successfully edited!',
    editContactSuccess: 'Contact successfully edited!',
    editInvoicingSuccess: 'Invoicing successfully edited!',
    details: 'Details',
    providers: 'Providers',
    mobilityProducts: 'Mobility Products',
    agreement: 'Overeenkomstnummer',
    department: 'Afdelingsnummer',
    departmentName: 'Afdelingsnaam',
    departments: 'Departments',
    company: 'Debiteurnummer',
    providerUpdatedSuccessfully: 'Provider data successfully updated!',
    commissionsUpdatedSuccessfully: 'Commissions successfully updated!',
    address: 'Address',
    role: 'Role',
    employee: 'Employee / Driver',
    dashboardAdmin: 'Dashboard Admin',
    dashboardSuperAdmin: 'Dashboard Super Admin',
    usage: 'Usage',
  },
  organisationUsage: {
    title: 'Usage fees',
    subtitle: 'Fees based on monthly snapshot. Is always invoiced afterwards.',
    feeType: 'Fee type',
    count: 'Count',
    feeAmount: 'Price excl VAT',
    startingFrom: 'Free units',
    total: 'Total / mo',
    totalUsageFee: 'Total usage fee',
    save: 'Save',
    updatedSuccessfully: 'Usage fees successfully updated!',
    ACTIVE_USERS: 'Active Users',
    INVITED_USERS: 'Invited Users',
    TRAVEL_CARD_USERS: 'Travel Card Users',
    NS_CARD_USERS: 'NS Business Card Users',
    DASHBOARD_USERS: 'Dashboard Users',
  },
  organisationInvoicing: {
    // Master toggle bar
    active: 'Active for invoicing',
    activeHint: 'When on, invoices are generated automatically and pushed to Exact.',
    // Subscription card
    subscriptionTitle: 'Subscription',
    contractStart: 'Subscription start date',
    billingFrequency: 'Billing frequency',
    monthly: 'Monthly',
    yearly: 'Yearly',
    custom: 'Custom',
    customMonths: 'Invoice every (months)',
    timingAfterwards: 'Invoiced afterwards',
    timingAdvance: 'Invoiced in advance',
    contractLength: 'Contract length',
    untilCancelled: 'Indefinite',
    fixedTerm: 'Fixed term',
    endsAfter: 'Ends after',
    unitMonth: 'month',
    unitMonths: 'months',
    unitYear: 'year',
    unitYears: 'years',
    unitCycle: 'cycle',
    unitCycles: 'cycles',
    contractEnds: 'Contract ends on $0.',
    subscriptionName: 'Subscription',
    subscriptionCustomOption: 'Custom name…',
    customSubscriptionName: 'Custom subscription name',
    customSubscriptionPlaceholder: 'e.g. Enterprise — ACME agreement',
    subscriptionPrice: 'Monthly price excl VAT',
    vat: 'VAT',
    vatDefault: 'Default (no / 0%)',
    discount: 'Monthly discount',
    save: 'Save',
    unsavedChanges: 'Unsaved changes',
    contractSaved: 'Subscription saved!',
    // One-time fees
    oneTimeTitle: 'One-time fees',
    oneTimeSubtitle:
      'Implementation fees, kickbacks and other one-off charges. Use a negative amount for a credit. Untick counts as revenue for pre-financed costs.',
    addItem: 'Add item',
    description: 'Description',
    amount: 'Amount excl VAT',
    invoiceMonth: 'Invoice month',
    invoicedOn: 'Invoiced on',
    countsAsRevenue: 'Counts as revenue',
    invoiced: 'Invoiced',
    noOneTime: 'No one-time fees yet.',
    itemsSaved: 'Items saved!',
    itemFieldsRequired: 'Every item needs a description and an invoice month.',
    // Commissions card
    commissionsTitle: 'Commissions',
    commissionsHint: 'Amount depends on actual ride volume in the period.',
    commissionsSaved: 'Commissions successfully updated!',
    // Next invoice preview
    previewTitle: 'Next invoice preview',
    earlierInvoiceOne: '1 earlier invoice from the contract was never generated.',
    earlierInvoicesMany: '$0 earlier invoices from the contract were never generated.',
    invoicedOnDate: 'Invoiced on $0',
    noUpcomingInvoices: 'No upcoming invoices.',
    viewAllScheduled: 'View all $0 scheduled invoices →',
    total: 'Total',
    exclRevenueTag: 'excl. stats',
    amountsExclVat: 'Amounts exclude VAT.',
    commissionsVariableNote: 'Commission amounts are variable and not included.',
    // Invoices (combined scheduled + invoiced)
    invoicesTitle: 'Invoices',
    invoicesSubtitle:
      'Everything already generated, plus what is scheduled from the settings above.',
    statusHeader: 'Status',
    invoiceHeader: 'Invoice',
    referenceHeader: 'Reference',
    dateHeader: 'Date',
    periodHeader: 'Period',
    subscriptionHeader: 'Subscription',
    usageHeader: 'Usage',
    otherHeader: 'Other',
    totalHeader: 'Total excl VAT',
    statusScheduled: 'Scheduled',
    statusInvoiced: 'Invoiced',
    statusDraft: 'Draft',
    scheduledCount: '$0 scheduled',
    noScheduledInvoices: 'No invoices scheduled.',
    schedNote: 'Scheduled rows are projections from the settings above and change when you save.',
    schedNoteOpenEnded: 'Showing the next $0 of an open-ended contract.',
    noValue: '—',
    // Invoice lines pop-up
    linesHint: 'Click an invoice to see its lines.',
    linesDialogTitle: 'Invoice lines',
    linesCountOne: '1 line',
    linesCountMany: '$0 lines',
    categoryHeader: 'Category',
    descriptionHeader: 'Description',
    lineAmountHeader: 'Amount excl VAT',
    lineAmountInclVatHeader: 'Amount incl VAT',
    totalInclVatHeader: 'Total incl VAT',
    categorySubscription: 'Subscription',
    categoryDiscount: 'Discount',
    categoryUsage: 'Usage',
    categoryOneOff: 'One-time',
    categoryPassthrough: 'Pre-financed',
    noLines: 'This invoice has no lines.',
    close: 'Close',
  },
  nsProvider: {
    NSBusinessCard: 'NS Business Card',
    updatedSuccessfully: 'NS data successfully updated!',
    agreement: 'Overeenkomstnummer',
    department: 'Afdelingsnummer',
    departmentName: 'Afdelingsnaam',
    departments: 'Departments',
    company: 'Debiteurnummer',
    save: 'Save',
    cardDeliveredAt: 'Card delivered at',
    officeAddress: 'Office Address',
    streetName: 'Street name',
    houseNumber: 'House number',
    addition: 'Addition',
    zipcode: 'Zip code',
    city: 'City',
    splitBilling: 'Split Billing',
    automaticallyAcceptRequests: 'Automatically Accept Requests',
    disabled: 'Disabled',
    enabled: 'Enabled',
  },
  mobilityProductsBlock: {
    Check: 'Check',
    Mywheels: 'Mywheels',
    Greenwheels: 'Greenwheels',
    enabled: 'Enabled',
    enabledForAllUsers: 'Enabled for all users',
    save: 'Save',
    cancel: 'Cancel',
    ok: 'OK',
    updatedSuccessfully: 'Mobility product successfully updated!',
    mywheelsWarningTitle: 'Note',
    mywheelsWarningMessage: 'Enabling Mywheels still requires some manual set-up, ask a developer!',
  },
  adyenProvider: {
    adyenSettings: 'Adyen settings',
    updatedSuccessfully: 'Adyen data successfully updated!',
    currency: 'Currency',
    topUpAmount: 'Top-up amount',
    notificationThreshold: 'Notification threshold',
    save: 'Save',
  },
  organisationEmail: {
    title: 'Email templates',
    description:
      'Make sure the text ends with a period ( . ) or leave the text field empty to disable.',
    save: 'Save',
    updatedSuccessfully: 'Email templates updated successfully!',
  },
  pushNotificationsPage: {
    title: 'Title ($0 / $1) characters',
    body: 'Body ($0 / $1) characters',
    uploadCSV: 'Upload CSV',
    send: 'Send',
    titleSingle: 'Title',
    bodySingle: 'Body',
    content: 'Content',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    dialogTitle: 'Are you sure you want send the following push notifaction to $0 users?',
    dialogSuccess: 'Push notifications successfully sent!',
    confirm: 'Confirm',
    cancel: 'Cancel',
    imported: 'Imported $0 users',
  },
  balanceAccountsPage: {
    name: 'Name',
    organisation: 'Organistaion',
    balance: 'Balance',
    reveal: 'Reveal',
    add: 'Add',
    close: 'Close',
    remove: 'Remove',
    dialogAddTitle: 'Adding funds to $0',
    dialogAddSuccess: 'Funds successfully added!',
    dialogRemoveTitle: 'Removing funds from to $0',
    dialogRemoveSuccess: 'Funds successfully removed!',
    amount: 'Amount in Euros',
    cancel: 'Cancel',
    confirm: 'Confirm',
    pleaseFillIn: 'Please fill in the organisation name to confirm.',
    funds: 'Funds',
    dialogWaitTitle: 'Please wait',
    dialogWaitMessage:
      "It takes a few minutes before clicking 'REVEAL' shows the new amount for $0.",
    ok: 'Ok',
    searchBalanceAccounts: 'Search balance accounts',
    balanceAccounts: 'balance accounts',
  },
  communitesPage: {
    communities: 'Communities',
    searchCommunities: 'Search communities',
    name: 'Name',
    size: 'Size',
    editable: 'Editable',
    addCommunity: 'Add community',
    deprecatedNotice:
      'Deprecated! Use organisation > Mobility Products to configure shared mobility access',
  },
  communityPage: {
    name: 'Name',
    cancel: 'Cance',
    restore: 'Restore',
    save: 'Save',
    update: 'Update',
    description: 'Description',
    fleets: 'Fleets',
    users: 'Users',
    successfullyAdded: 'Community successfully added',
    successfullyEdited: 'Community successfully edited',
    deleteCommunity: 'Delete community',
    confirm: 'Confirm',
    deleteCommunitySuccess: 'Community successfully deleted!',
    areYouSure: 'Are you sure?',
    dialogDeleteMessage:
      'You are about to delete the community $0. This action cannot be ondone. Please enter the community name again to confirm.',
    email: 'Email',
  },
  invitesPages: {
    name: 'Name',
    email: 'Email',
    code: 'Code',
    timesRedeemed: 'Times redeemed',
    timesUsedByInvitee: 'Times used by invitee',
    timesUsedByInviter: 'Times used by inviter',
    searchEmailOrCode: 'Search email or code',
    emailOrCode: 'Email or code',
    exportAllInivites: 'Export all invites',
  },
  transactionRuleGroupsPage: {
    title: 'Transaction Rules Groups',
    name: 'Name',
    description: 'Description',
    type: 'Type',
    amountOfCodes: 'Amount of codes',
    add: 'Add new group',
  },
  transactionRuleGroupPage: {
    title: 'Transaction Rules Groups',
    name: 'Name',
    description: 'Description',
    type: 'Type',
    amountOfCodes: 'Amount of codes',
    codes: 'Codes',
    add: 'Add new group',
    delete: 'Delete',
    save: 'Save',
    update: 'Update',
    restore: 'Restore',
    successfullyAdded: 'Successfully added group',
    successfullyUpdated: 'Successfully updated group',
    successfullyDeleted: 'Successfully deleted group',
  },
  customPage: {
    custom: 'Custom',
    customReports: 'Custom Reports',
    ijmondBereikbaarExport: 'Ijmond Bereikbaar Export Excel',
  },
} as const;

// Add new languages here
// const dutchTranslations: typeof englishTranslations = {
//   loginPage: {
//     verificationCode: 'dit is Nederlands',
//     ...
//   },
//   mainPage: {
//     ...
//   },
// };

// Add new languages here
// type LocalizedContent = typeof englishTranslations | typeof dutchTranslations;
type LocalizedContent = typeof englishTranslations;

type CustomKeys3<A> = { [B in keyof A]: A[B] extends object ? A[B][keyof A[B]] : never };
type CustomString = CustomKeys3<LocalizedContent>[keyof CustomKeys3<LocalizedContent>];

// Add new languages here
// type Languages = 'english' | 'dutch;
type Languages = 'english';

export { type CustomString, englishTranslations, type Languages, type LocalizedContent };
